
export const PAPERS = {
  workingPapers: [
     {
      id: 'terms-of-trade-shocks',
      title: "Identifying Terms-of-Trade Shocks with Foreign Weather: Implications for Monetary Policy",
      authors: "Solo work", //Solo work
      abstract: "How do the terms of trade (ToT) affect the macroeconomy, and how should monetary policy respond? I identify exogenous ToT shocks for 48 economies by combining a rich set of high-frequency weather shocks from foreign territories with bilateral trade flows. I apply machine learning methods to map high-dimensional weather shocks into low-dimensional components that predict future ToT growth out of sample, while avoiding overfitting. Using panel local projections, I show that negative ToT shocks are contractionary and inflationary, creating a policy tradeoff under floating exchange rates. A shock that causes a 10% decline in the ToT one year ahead raises prices by 3% and reduces economic activity by 1.5% in the medium run (5 years). Stabilizing inflation requires preemptive contractionary policy of 46 bps, offsetting 90% of the shock’s cumulative effects, while closing the output gap calls for preemptive expansionary policy of 20 bps, neutralizing 70% respectively.",
      link: "https://taipliadis.com/resources/JMP_Taipliadis.pdf",
      slides: "https://drive.google.com/file/d/184VXojxKsOEt4BJPTgiyxUlCAiM9uUDg/view?usp=drive_link",
      dataLink: "https://docs.google.com/spreadsheets/d/18AJtblK2GOAGx_-qe0F4BwhKCdqztrde5Ut1HaL1vvs/edit?usp=sharing",
      status: "JMP" //Under review
    },
    {
      id: 'optimal-monetary-policy',
      title: "The Optimal Monetary Policy Response to Belief Distortions: Model-Free Evidence",
      authors: "with Jonathan J. Adams",
      abstract: "Households’ inflation expectations are often inconsistent with the full information rational expectation. Economic theory predicts that these belief distortions affect the business cycle. How then might monetary policy respond? We investigate with a model-free approach using high-frequency monetary policy shocks and a structural VAR method to identify the effects of shocks to belief distortions. Belief distortion shocks are contractionary; if households become overly pessimistic about inflation, then unemployment and deflation follow. Intuitively, our method implies that the optimal policy response is to ease: a 1 percentage point increase in the belief distortion is optimally offset by a 0.85 percentage point surprise interest rate decrease. Unconventional monetary policy is less effective than using short-run rates in our setting.",
      link: "https://jonathanjadams.com/files/Adams%20Taipliadis/Optimal_Monetary_Policy_Response_to_Belief_Distortions.pdf",
      gitLink: "https://github.com/taipliadis/optimal-mp-belief-distortions",
      status: "Revise and Resubmit at International Journal of Central Banking"
      // year: "2025"
    },
    {
      id: 'heterogeneous-responses',
      title: "Heterogeneous Responses to Signals and the Predictability of Forecast Errors",
      authors: "Solo work",
      abstract: "Why do analysts underreact to news at the aggregate level yet overreact at the individual level? The literature explains underreaction with information frictions and overreaction with extrapolation from recent events. However, forecast revisions are weak predictors of forecast errors out-of-sample. I instead argue analysts overvalue private signals while underweighting public signals. To test this, I propose a novel method to disentangle responses to private signals from heterogeneous responses to public signals in high-frequency data. Using data from professional analysts’ expectations of US firm revenues, I find that asymmetric responses to signals uncover behavioral bias that predicts forecast errors out-of-sample.",
      link: "https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4776880",
      appendix: "https://drive.google.com/file/d/1I0NskpIO4rsSujY-PUtgQA6S6qTzaTvm/view?usp=drive_link",
      status: "Reject and Resubmit at European Economic Review"
      // year: "2024"
    }
  ],
  workInProgress: [
    {
      id: 'optimal-disclosure-fiscal',
      title: "Optimal Disclosure in Fiscal Policy: Evidence from a Structural VAR",
      authors: "Solo work"
      //abstract: "(available soon)"
      //expectedCompletion: "Summer 2026"
    },
    {
      id: 'perceived-drivers-of-inflation',
      title: "Perceived Drivers of Inflation: An Expectations-Based Decomposition of Demand and Supply Shocks",
      authors: "Solo work"
      //abstract: "(available soon)"
      //expectedCompletion: "Summer 2026"
    },
    {
      id: 'optimal-mp-tariffs',
      title: "The Optimal Monetary Policy Response to Tariffs: Model-Free Evidence",
      authors: "with Phillip G. Khaskin"
      //abstract: "(available soon)"
      //expectedCompletion: "Summer 2026"
    },
    {
      id: 'do-beliefs-and-frictions-earn-risk-premia',
      title: "Do Beliefs and Frictions Earn Risk Premia? Analyst-Based Factors",
      authors: "Solo work"
      // abstract: "(available soon)"
      // expectedCompletion: "Summer 2026"
    },
    {
      id: 'lender-last-resort',
      title: "Lender of Last Resort: An Unconventional Macroprudential Policy",
      authors: "Solo work"
      //abstract: "(available soon)"
      // expectedCompletion: "Summer 2026"
    }
  ]
};
